import React from 'react'
import { FaqCardProps } from '../index'

export const FaqCard = ({ imageURL, title, cardURL }: FaqCardProps) => {
    return (
        <div>
            <a href={cardURL} target="_blank" className="relative" rel="noreferrer">
                <div className="flex flex-col max-w-[225px] min-h-[183px] rounded-2xl drop-shadow-lg bg-white relative">
                    <div className="pt-5 pl-3">
                        <img alt={'FAQ icon'} src={imageURL} />
                    </div>
                    <p className="text-sm font-medium text-black p-4 pt-2">{title}</p>
                    <img
                        className="absolute right-0 bottom-0 max-w-[93%] rounded-br-2xl"
                        src="https://asset.yes.fit/homepage/faq-bottom.png"
                    />
                </div>
            </a>
        </div>
    )
}
